import UomTypes from '../types/UomTypes';

const initialState = {
  isLoading: false,
  uomData: [],
  uomItemData: {},
  activeUom: [],
  queryParams: {
    paginationData: { page: 0, pageSize: 10 },
    sortingData: { sortField: '', sort: '' },
    keyword: ''
  }
};

// eslint-disable-next-line default-param-last
const uom = (state = initialState, action) => {
  switch (action.type) {
    case UomTypes.GET_UOM_LIST_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case UomTypes.GET_UOM_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        uomData: action.payload
      };
    case UomTypes.GET_UOM_LIST_ERROR:
      return {
        ...state,
        isLoading: false,
        uomData: []
      };

    case UomTypes.GET_UOM_ITEM_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case UomTypes.GET_UOM_ITEM_SUCCESS:
      return {
        ...state,
        isLoading: false,
        uomItemData: action.payload
      };
    case UomTypes.GET_UOM_ITEM_ERROR:
      return {
        ...state,
        isLoading: false,
        uomItemData: []
      };
    case UomTypes.GET_ACTIVE_UOM_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case UomTypes.GET_ACTIVE_UOM_SUCCESS:
      return {
        ...state,
        isLoading: false,
        activeUom: action.payload
      };
    case UomTypes.GET_ACTIVE_UOM_ERROR:
      return {
        ...state,
        isLoading: false,
        activeUom: []
      };
    case UomTypes.UPDATE_UOM_QUERY_PARAMS:
      return {
        ...state,
        queryParams: {
          // ...state.queryParams,
          paginationData: action.payload.paging,
          sortingData: action.payload.sorting,
          keyword: action.payload.keyword
        }
      };

    default:
      return state;
  }
};
export default uom;
